import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 2
const slug = 'emergency-power-restoration-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Emergency Power Restoration Sydney | ${BUSINESS_NAME}`,
        description: "Rapid-response electricians available day or night to restore power and fix urgent electrical issues.",
        keywords: "emergency power restoration Sydney, urgent electrical repairs, 24/7 electrician Sydney, power outage solutions, electrical fault diagnosis, residential emergency electrician, commercial emergency electrical services, backup power systems, electrical safety inspections, rapid-response electricians",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Emergency Power Restoration',
    description: 'Rapid-response electricians available day or night to restore power and fix urgent electrical issues.',
    points: [
    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
